import React from 'react'
import { StyledGlStack, StyledGlTitle } from 'styles/globals'

export default function StackCm(props) {
  return (
    <StyledGlStack>
        {props.title ? <StyledGlTitle>{props.title}</StyledGlTitle> : ""}
        {props.children}
    </StyledGlStack>
  )
}
